<p-dialog [header]="header()" [modal]="true" [(visible)]="showModal" [closeOnEscape]="false"
  [style]="{ width: '50vw' }"
  [breakpoints]="{ '1300px': '75vw', '1000px': '90vw' }">
  <div class="w-full">
    <div class="flex justify-between w-full">
      <div class="flex flex-col">
        <label class="form-label" for="InvestigatorComments">
          {{ "CASE_DETAIL.INVESTIGATOR_TAGS" | translate }}
        </label>
        @if (apiUrl.includes('coreact')) {
          <p-dropdown
            [options]="investigationStatuses()"
            optionLabel="name"
            optionValue="name"
            display="chip"
            (onChange)="onChangeSingleTag($event)"
            placeholder="Select Tag"
            [disabled]="selectedResult().tags.length > 0"
            appendTo="body"
            class="w-full md:w-80"
          ></p-dropdown>
          
        } @else {
          <p-multiselect
            [options]="investigationStatuses()"
            [(ngModel)]="selectedResult().tags"
            optionLabel="name"
            [placeholder]="'CASE_DETAIL.ADD_TAGS' | translate"
            display="chip"
            appendTo="body"
            styleClass="w-full md:w-80"
            (onRemove)="removeTag($event)">
          </p-multiselect>
        }
        @if(selectedResult().tags.length > 0){
          <div class="flex flex-wrap gap-1 mt-1">
            @for(tag of selectedResult().tags; track $index){
              <lib-chip
                [tag]="tag"
                [removable]="true"
                (onRemove)="removeTag(tag)">
              </lib-chip>
            }
          </div>
        }
         @if (apiUrl.includes('coreact')) {
        <div class="flex flex-col mt-3">
            <label class="form-label">
              {{ "CASE_DETAIL.SAVED_AMOUNT" | translate }}
            </label>
            <input
              type="number"
              pInputText
              min="0"
              class="w-full"
              [ngModel]="tempSavedAmount()"
              (ngModelChange)="tempSavedAmount.set($event)"
              style="
                  appearance: textfield;
                  -moz-appearance: textfield;
                "
            />
          </div>}
      </div>
      <div class="self-end">
        <app-file-upload
          #fileUpload
          [selectedFiles]="selectedResult().files"
          (onRemoveFile)="onRemoveFile($event)"
          (onUploadFile)="uploadFiles($event)">
        </app-file-upload>
      </div>
    </div>
    <div class="flex flex-col mt-3">
      <div class="flex items-center justify-between">
        <label for="investigationComments" class="form-label">
          {{ "CASE_DETAIL.INVESTIGATION_COMMENTS" | translate }}
        </label>
        <i
          class="fa fa-trash cursor-pointer"
          [class.text-danger]="!commentMarkedForDeletion()"
          [class.text-warning]="commentMarkedForDeletion()"
          (click)="onDeleteCommentClick()"
          title="Delete comment"
        ></i>
      </div>
      <textarea
        id="investigationComments"
        [ngModel]="selectedResult().comment"
        (ngModelChange)="onCommentChange($event)"
        pTextarea
        [autoResize]="false"
        [fluid]="true">
      </textarea>
    </div>
  </div>
  <ng-template #footer>
    <button (click)="onInvestigationResultSubmit()" class="!text-white" [disabled]="isSubmitDisabled"
      pButton [severity]="'primary'">
      {{ "CASE_DETAIL.SAVE" | translate }}
    </button>
    <button pButton [severity]="'secondary'" type="button" class="!bg-gray-400 !text-dark"
      (click)="showModal.set(false)">
      {{ "CASE_DETAIL.CLOSE" | translate }}
    </button>
  </ng-template>
</p-dialog>